import {IconProps} from "types/types";

export default function ArrowLeftIcon({
                                          color = "#000",
                                          width = 24,
                                          height = 25,
                                          ...props
                                      }: IconProps) {
    return <svg width={width} height={height} {...props} viewBox="0 0 24 25" fill="none"
                xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M10.2322 5.26777L11.1161 6.15165L5.55207 11.7157H20.2157L20.2157 12.962L5.55207 12.962L11.1161 18.526L10.2322 19.4099L3.16117 12.3388L10.2322 5.26777Z"
              fill={color}/>
    </svg>

}